import { render } from "./WarningMessageWithButton.vue?vue&type=template&id=173b4b7d&scoped=true&ts=true"
import script from "./WarningMessageWithButton.vue?vue&type=script&lang=ts"
export * from "./WarningMessageWithButton.vue?vue&type=script&lang=ts"

import "./WarningMessageWithButton.vue?vue&type=style&index=0&id=173b4b7d&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-173b4b7d"]])

export default __exports__